export default __webpack_public_path__ + "6d0669ed3cfc9b25bcf34017c73a9065.svg";